// extracted by mini-css-extract-plugin
export var cardHeader = "_fu-0";
export var reorderHandle = "_fu-3";
export var titleArea = "_fu-1";
export var titleAreaWithHandle = "_fu-2";